module.exports = __webpack_public_path__ + "static/media/csv-up.c444a7e3.svg";